"use client";

import Link from "next/link";

/**
 * @param {{ id: number, title: string, description: string, questions: number, featuredImage: string | null, isAnonymous?: boolean, allowMultiple?: boolean, status?: string, hasResponded?: boolean }} survey
 */
export default function SurveyCard({ survey }) {
  const href = `/services/surveys/${survey.id}`;
  const closed = survey.status === "closed";
  const responded = Boolean(survey.hasResponded);
  const blocked = closed || (responded && !survey.allowMultiple);

  return (
    <article className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden survey-card">
      <Link href={href} className="text-decoration-none text-body">
        <div className="position-relative">
          {survey.featuredImage ? (
            <div className="ratio ratio-16x9 bg-light">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src={survey.featuredImage} alt="" className="object-fit-cover w-100 h-100 rounded-top" loading="lazy" />
            </div>
          ) : (
            <div className="ratio ratio-16x9 bg-dark d-flex align-items-center justify-content-center">
              {/* <i className="bi bi-ui-checks display-4 text-primary opacity-75" aria-hidden /> */}
            </div>
          )}
          <div className="position-absolute top-0 end-0 m-2 d-flex flex-column gap-1 align-items-end">
            {survey.isAnonymous && (
              <span className="badge rounded-pill bg-dark bg-opacity-75">الخصوصية</span>
            )}
            {responded && !survey.allowMultiple && (
              <span className="badge rounded-pill bg-success">شاركت مسبقاً</span>
            )}
            {closed && (
              <span className="badge rounded-pill bg-secondary">مغلق</span>
            )}
          </div>
        </div>
        <div className="card-body p-4">
          <h2 className="h5 fw-bold mb-2 text-truncate">{survey.title}</h2>
          <p className="text-muted small mb-3" style={{ minHeight: "2.75rem" }}>
            {survey.description || "استبيان — شاركنا رأيك"}
          </p>
          <div className="d-flex align-items-center justify-content-between text-muted small">
            <span>
              <i className="bi bi-list-check ms-1" aria-hidden />
              {survey.questions || 0} سؤال
            </span>
            <span className={`fw-semibold ${blocked ? "text-secondary" : "text-primary"}`}>
              {blocked ? (closed ? "التفاصيل" : "عرض") : "ابدأ"}
              <i className="bi bi-chevron-left me-1" aria-hidden />
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}
